import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo, MensajeCapcha } from '../../mensajes2';
import { Dimmer } from '../../spinner';

import {
    ValidCaptcha, validaSoloNumero, formatMoneda, validaMonto, formatoMonto,
    seleccionarCampo, validaNumeroTelefono, validaEmail
} from '../../../util/varios';
import 'react-tabs/style/react-tabs.css';
import axios from 'axios';
import moment from 'moment';
import TablaPb from './modalTablaPb';


export const ActualizarPublicidad = (props) => {

    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [activate, setActivate] = useState(false);
    const txtFechaReg = useRef();
    const txtAlto = useRef();
    const txtAncho = useRef();
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [anioActu, setAnioActu] = useState(localStorage.getItem('anioactu'));
    const txtTotalMetros = useRef();
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [visible, setVisible] = useState(false);
    const [idefiscal, setIdefiscal] = useState(localStorage.getItem('idefiscal'));
    const txtTotal = useRef();
    const txtValorUT = useRef();
    const txtValorUC = useRef();
    const txtIDP = useRef();
    const txtIDC = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    const [totalu, setTotalu] = useState(0.00);
    const [totaluc, setTotaluc] = useState(0.00);
    const [totalmetros, setTotalMetros] = useState(0.00);
    const [total, setTotal] = useState(0.00);
    const txtMonto = useRef();
    const txtNunid = useRef();
    const [habilitadoNR, setHabilitadoNR] = useState(false);
    const txtAiVial = useRef();
    const txtUbicacion = useRef();
    const txtUni = useRef();
    const txtEsct = useRef();
    const txtPinb = useRef();
    const txtPuso = useRef();
    const [values, setValues] = useState({
        idpublicidad: '',
        idcomercio: '',
        fechainscripcion: '',
        ancho: 0.00,
        alto: 0.00,
        recautinsvialreg: '',
        reccroquisubi: '',
        recplanoestructura: '',
        recautpropieinmue: '',
        recusoconfddu: '',
        ubicacion: '',
        anio: ''
    });
    const [valuesp, setValuesp] = useState({
        idtipopublicidad: '',
        descripcion: '',
        codigoordenanza: '',
        monto: '',
        numerounidad: ''
    });



    const Actualizar = (operacion) => {

        let endpoint = `${op.conexion}/api/publicidad/createpublicidad/${operacion}`;
        let body;
        setActivate(true);

        body = {

            idpubli: parseInt(txtIDP.current.value),
            idcome: parseInt(props.idcomercio),
            idtipo: parseInt(valuesp.idtipopublicidad),
            nancho: txtAncho.current.value.trim().replace(/\./g, '').replace(',', '.'),
            nalto: txtAlto.current.value.trim().replace(/\./g, '').replace(',', '.'),
            ncantidad: txtTotalMetros.current.value.trim().replace(/\./g, '').replace(',', '.'),
            nmonto: txtTotal.current.value.trim().replace(/\./g, '').replace(',', '.'),
            //nmonto: txtValorUC.current.value.trim().replace(/\./g, '').replace(',', '.') * txtTotalMetros.current.value.trim().replace(/\./g, '').replace(',', '.'),
            fecins: txtFechaReg.current.value,
            nanio: anioActu,
            reccro: txtUni.current.checked ? true : false,
            recplano: txtEsct.current.checked ? true : false,
            recautori: txtPinb.current.checked ? true : false,
            recinsvial: txtAiVial.current.checked ? true : false,
            recuso: txtPuso.current.checked ? true : false,
            ubi: txtUbicacion.current.value.trim(),
            factorcambio: props.factorCambio
        };

        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {

                if (props.operacion === 1) {


                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Creado Correctamente.', icono: 'exito' });


                } else if (props.operacion === 2) {


                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Modificado Correctamente.', icono: 'exito' });


                } else if (props.operacion === 3) {



                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Eliminado Correctamente.', icono: 'exito' });


                }

            }
            setActivate(false);
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const handleCloseSi = () => {
        setMostrar1(false);
    };

    const handleCloseNo = () => {
        setMostrar1(false);
    };


    const cerrarModal = () => {

        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        if (mensaje.texto === 'Registro Creado Correctamente.' || mensaje.texto === 'Registro Modificado Correctamente.' || mensaje.texto === 'Registro Eliminado Correctamente.') {

            props.onRederizar(props.idcomercio, props.annio);
            props.onHideCancela();

        }

    }




    const onCalculo = (totu) => {

        let alto = 0.00, ancho = 0.00, metro = 0.00;
        let ut = totu;
        let totalValor = 0.00;

        alto = parseFloat(txtAlto.current.value.trim().replace(/\./g, '').replace(',', '.'));
        ancho = parseFloat(txtAncho.current.value.trim().replace(/\./g, '').replace(',', '.'));
        metro = alto * ancho;
        setTotalMetros(metro);
        totalValor = ut * metro;
        setTotal(totalValor);
    }

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (valuesp.idtipopublicidad === '') {

            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Por Favor Seleccione el Clasificador de Publicidad', icono: 'informacion' });

            sigue = false;

        } else if (txtFechaReg.current.value.trim() === '') {

            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha de Registro no debe ir Vacio', icono: 'informacion' });

            sigue = false;
            txtFechaReg.current.focus();

        } else if (txtAlto.current.value.trim() === '' || txtAncho.current.value === '') {

            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Por Favor Introdusca las Unidades de Medida', icono: 'informacion' });

            sigue = false;
            txtAlto.current.focus();

        } else if (txtUbicacion.current.value.trim() === '') {

            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir la Ubicación', icono: 'informacion' });


            sigue = false;
            txtUbicacion.current.focus();

        } else if (sigue === true) {

            Actualizar(props.operacion);
        }
    }

    const handleCloseCatag = () => {
        setMostrar3(false);
    }


    const blanquear = () => {

        setVisible(false);
        setMostrar1(false);
        setActivate(false);
        setValues({
            idpublicidad: '',
            idcomercio: '',
            fechainscripcion: '',
            ancho: 0.00,
            alto: 0.00,
            recautinsvialreg: '',
            reccroquisubi: '',
            recplanoestructura: '',
            recautpropieinmue: '',
            recusoconfddu: '',
            ubicacion: '',
            anio: ''
        });
        setValuesp({
            idtipopublicidad: '',
            descripcion: '',
            codigoordenanza: '',
            monto: '',
            numerounidad: ''
        });
        setTabIndex(0);
        setOperacion(0);
        setTotalMetros(0.00);
        setTotal(0.00);
        setTotalu(0.00);
        setTotaluc(0.00);
        setMsg('');

    }

    const onChange = (event) => {

      /*  */  console.log(event.target.name)

        if (event.target.name === 'ubicacion') {
            event.target.value = event.target.value.toUpperCase();
            setValues({ ...values, [event.target.name]: event.target.value });
        }


    };



    const handleInputMontoChange = (event) => {
        // Validar el monto (función existente)
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        /*console.log(event.which)

        // Obtener el valor del input sin caracteres no válidos
        let value = event.target.value.replace(/[^0-9,]/g, ''); // Solo números y coma decimal

        // Si ya existe una coma decimal, permitir solo una
        if ((value.match(/,/g) || []).length > 1) {
            value = value.replace(/,+$/, ''); // Elimina comas adicionales
        }

        // Formatear el valor como monto con dos decimales
        event.target.value = formatoMonto(value); // Puedes implementar tu formato aquí

        // Si es presionada la tecla Enter (keyCode 13) o si no es detectable 'which'*/
        if (event.which === 13 || typeof event.which === 'undefined') {
            /* if (event.target.value === "" || parseFloat(event.target.value.replace(/\./g, "").replace(",", ".")) === 0) {
                event.target.value = "0,00";
            } */
            event.target.value = formatoMonto(event.target.value);
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === "0" && char2 !== ",") {
                event.target.value = event.target.value.substring(1, event.target.value.length);
            }

            onCalculo(totalu);

            // Llamar al cálculo después de la validación y el formateo
        } else if (event.which === 46) {
            return false; // Evitar el punto (usar coma en su lugar)
        } else if (event.which >= 48 && event.which <= 57) {
            return true; // Permitir números
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true; // Permitir borrar, teclas especiales, y la coma
        } else {
            return false; // Evitar cualquier otra tecla
        }

        
        
        


        // Controlar otras teclas
        
    };

    // Función para formatear el monto
    const formatoMonto = (value) => {
        // Asegurarse de que el valor tiene siempre dos decimales
        let parts = value.split(',');
        if (parts[1]?.length > 2) {
            parts[1] = parts[1].substring(0, 2); // Limitar a dos decimales
        }

        // Unir las partes de nuevo y formatear con coma decimal
        return parts.join(',');
    };


    const cancelar = (e) => {
        e.preventDefault();
        setHabilitadoNR(false);
        blanquear();
        props.onHideCancela();

    }

    const catalogoPb = () => {

        setMostrar3(true);

    };


    const handleAceptarPb = (valor) => {
        setMostrar3(false);
        setValuesp({ ...values, idtipopublicidad: valor.idtipopublicidad, descripcion: valor.descripcion, codigoordenanza: valor.codigoordenanza, monto: valor.monto, numerounidad: valor.numerounidad });

        let totaal = 0.00;
        let totalUd = 0.00;

        let num = parseFloat(valor.numerounidad);
        let monto = parseFloat(valor.monto);
        let factor = parseFloat(props.factor.factorcalculo);

        totaal = monto * props.factorCambio;
        totalUd = monto / num;


        setTotalu(totaal);
        setTotaluc(monto);
        /*if (factor === 1) {
            setTotalu(totalUd);
        } else if (factor === 2 || factor === 3 || factor === 4 || factor === 5) {
            setTotalu(totaal);
        }*/

        onCalculo(totaal)

    }


    const handleInputBlur = (e) => {
        console.log(e.target.value)
        if(e.target.value.length === 1 || e.target.value.length === 2){
            e.target.value = e.target.value+',00'
        }

    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.3)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setVisible(false);
                btnAcepta.current.focus();
                setOperacion(props.operacion);
                setTabIndex(0);
                if (props.operacion !== 1) {

                    setValues(props.publicidad);
                    setValuesp(props.tpublicidad);

                    let num = 1.00;
                    let monto = 0.00;
                    let factor = 0.00;
                    let udt = 0.00;
                    let valor = 0.00;
                    let total = 0.00;
                    udt = parseFloat(props.valorut);
                    num = props.tpublicidad ? props.tpublicidad.numerounidad !== null ? parseFloat(props.tpublicidad.numerounidad) : 0.00 : 0.00;
                    monto = props.tpublicidad ? props.tpublicidad.monto !== null ? parseFloat(props.tpublicidad.monto) : 0.00 : 0.00;
                    factor = props.factor ? props.factor.factorcalculo !== null ? parseFloat(props.factor.factorcalculo) : 0.00 : 0.00;
                    valor = monto * props.factorCambio;
                    total = monto / num;

                    console.log('factpr ' + factor)
                    setTotalu(valor);
                    setTotaluc(monto);
                    /*if (factor === 1) {
                        setTotalu(total);
                    } else if (factor === 2 || factor === 3 || factor === 4 || factor === 5) {
                        setTotalu(valor);
                    }*/

                    let alto = props.publicidad ? props.publicidad.alto !== null ? parseFloat(props.publicidad.alto) : 0.00 : 0.00;
                    let ancho = props.publicidad ? props.publicidad.ancho !== null ? parseFloat(props.publicidad.ancho) : 0.00 : 0.00;
                    let totalM = 0.00;
                    totalM = alto * ancho;
                    setTotalMetros(totalM);
                    setTotal(totalM * valor);
                    /*if (factor === 1) {
                        setTotal(totalM * total);
                    } else if (factor === 2 || factor === 3 || factor === 4 || factor === 5) {
                        setTotal(totalM * valor);
                    }*/



                }

            }}

        >
            <Modal.Header className='azulGradiant' style={{ height: '40px' }}>
                <div style={{ color: "#fff", fontSize: 20 }}>{operacion === 1 ? 'Incluir Publicidad.' : operacion === 2 ? 'Modificar Publicidad.' : operacion === 3 ? 'Eliminar Publicidad.' : 'Consultar Publicidad.'}</div>
                <div className="input-group input-group-sm col-md-3 mr-0 my-auto">
                    <span className="input-group-text bg-transparent fw-bold border-0 text-light">
                        Valor U. C:
                    </span>
                    <span className="input-group-text bg-transparent fw-bold border-0  text-light">
                        {formatMoneda(props.factorCambio.toString().replace(",", "").replace(".", ","), ",", ".", 2) + ' Bs.'}
                    </span>
                </div>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#f8f9fa", color: "" }}>
                <TablaPb
                    show={mostrar3}
                    onHideAceptaCatPb={handleAceptarPb}
                    onHideCloseCatag={handleCloseCatag} />
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />

                <Dimmer active={activate} inverted>

                </Dimmer>
                <div style={{ height: "auto", overflow: "auto" }}>
                    <div className='row border rounded mx-auto'>
                        <div className='container' style={{ backgroundColor: "", color: "" }}>
                            <div className="container row mx-auto">
                                <input type="hidden" ref={txtIDP} className="form-control text-uppercase" name='idpublicidad' value={values && values.idpublicidad} />
                                <input type="hidden" ref={txtIDC} className="form-control text-uppercase" name='idcomercio' value={values && values.idcomercio} />
                                <div className="col-md-11">
                                    <table className="table table-sm v-100" style={{ fontSize: '12px' }}>
                                        <thead className="thead">
                                            <tr className='text-center'>
                                                <th className='col-md-2 fw-bold'>Codigo</th>
                                                <th className='col-md-2 fw-bold'>Codigo/Ordenanza</th>
                                                <th className='col-md-5 fw-bold'>Descripción</th>
                                                <th className='col-md-5 fw-bold'>Monto</th>

                                                <th className='col-md-2 fw-bold'>Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody className='table-secondary text-center'>
                                            <tr>
                                                <td className='col-md-2'>{valuesp ? valuesp.idtipopublicidad : ''}</td>
                                                <td className='col-md-2'>{valuesp ? valuesp.codigoordenanza : ''}</td>
                                                <td className='col-md-5 text-center'>{valuesp ? valuesp.descripcion ? valuesp.descripcion.trim() : '' : ''}</td>
                                                <td className='col-md-2'>
                                                    <input /* type="hidden" */ ref={txtMonto} disabled className="form-control text-end my-auto" name='monto' value={valuesp && valuesp.monto ? formatMoneda(valuesp.monto.replace(',', '').replace('.', ','), ',', '.', 2) : '0,00'} id="inputMonto" />
                                                </td>
                                                <input type="hidden" ref={txtNunid} className="form-control text-uppercase" name='numerounidad' value={valuesp && valuesp.numerounidad ? formatMoneda(valuesp.numerounidad.replace(',', '').replace('.', ','), ',', '.', 2) : ''} id="inputNumu" />
                                                <td className='col-md-2'><input type="date" ref={txtFechaReg} disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} className="form-control text-uppercase" name='fechainscripcion' defaultValue={values && values.fechainscripcion ? moment.utc(values.fechainscripcion).format('YYYY-MM-DD') : moment.utc(values.fechaSistema).format('YYYY-MM-DD')} onChange={onChange} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-1 pt-4">
                                    <thead class="thead mx-auto my-auto">
                                        <tr className='mx-auto my-auto'>
                                            <th scope="col my-auto"><button disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} onClick={catalogoPb} className="btn btn-info ml-2 btn-sm rounded-circle my-auto"><i class="fas fa-search"></i></button></th>
                                        </tr>
                                    </thead>
                                </div>
                            </div>
                            <div className=' border mb-2 rounded col-md-12 mx-auto row py-2'>
                                <div className="container">
                                    <label style={{ fontWeight: 'bold' }}>Unidad de Medida</label>
                                </div>

                                <div className="input-group input-group-sm mb-3 col-md-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text w-100">Alto m²: </span>
                                    </div>
                                    <input
                                        type="text"
                                        disabled={operacion === 4 || operacion === 3 ? true : deshabilitado}
                                        placeholder="Mts"
                                        ref={txtAlto}
                                        className="form-control text-right"
                                        name="alto"
                                        defaultValue={values && values.alto ? formatMoneda(values.alto.replace(',', '').replace('.', ','), ',', '.', 2) : ''}
                                        onChange={handleInputMontoChange}
                                        onBlur={handleInputMontoChange} // Usamos handleInputBlur para el evento de perder el foco
                                        id="inputAlto"
                                    />
                                </div>
                                <div className="input-group input-group-sm mb-3 col-md-3">
                                    <div className="input-group-prepend" >
                                        <span className="input-group-text w-100">Ancho m²: </span>
                                    </div>
                                    <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} onBlur={handleInputBlur} placeholder="Mts" ref={txtAncho} className="form-control text-right" name='ancho' defaultValue={values && values.ancho ? formatMoneda(values.ancho.replace(',', '').replace('.', ','), ',', '.', 2) : ''} onChange={handleInputMontoChange}  id="inputAncho" />
                                </div>
                                <div className='col-md-1'></div>
                                <div className="input-group input-group-sm mb-3 col-md-5">
                                    <div className="input-group-prepend" >
                                        <span className="input-group-text w-100">Total m²: </span>
                                    </div>
                                    <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtTotalMetros} className="form-control text-right" name='totalmetros' value={formatMoneda(totalmetros.toString().replace(',', '').replace('.', ','), ',', '.', 2)} />
                                </div>

                                {/*     <hr className='mx-auto' />
 */}
                                <div className="input-group input-group-sm mb-1 col-md-4">
                                    <div className="input-group-prepend" >
                                        <span className="input-group-text w-100">Valor U. C.: </span>
                                    </div>
                                    <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtValorUC} className="form-control text-right" value={formatMoneda(totaluc.toString().replace(',', '').replace('.', ','), ',', '.', 2)} />
                                </div>

                                <div className="input-group input-group-sm mb-1 col-md-4">
                                    <div className="input-group-prepend" >
                                        <span className="input-group-text w-100">Valor Unitario Bs.: </span>
                                    </div>
                                    <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtValorUT} className="form-control text-right" value={formatMoneda(totalu.toString().replace(',', '').replace('.', ','), ',', '.', 2)} />
                                </div>
                                <div className="input-group input-group-sm mb-1 col-md-4">
                                    <div className="input-group-prepend" style={{ width: 90 }}>
                                        <span className="input-group-text w-100">Valor Total Bs.: </span>
                                    </div>
                                    <input type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtTotal} className="form-control text-right" value={formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2)} />
                                </div>


                            </div>
                            <div className='container border rounded mb-2 col-md-12'>
                                <div className="container mt-2">
                                    <label style={{ fontWeight: 'bold' }}>Copias de Recaudos</label>
                                </div>
                                <div className="container row">
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtUni} defaultChecked={props.publicidad && props.publicidad.reccroquisubi === true ? true : false} id="croquisUbicacion" />
                                            <label className="form-check-label" htmlFor="croquisUbicacion">
                                                Croquis de Ubicación
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtEsct} defaultChecked={props.publicidad && props.publicidad.recplanoestructura === true ? true : false} id="planoEstructura" />
                                            <label className="form-check-label" htmlFor="planoEstructura">
                                                Plano de la Estructura
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtPinb} defaultChecked={props.publicidad && props.publicidad.recautpropieinmue === true ? true : false} id="autPropiedad" />
                                            <label className="form-check-label" htmlFor="autPropiedad">
                                                Aut. Propiedad Inmobiliaria
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="container row">
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtAiVial} defaultChecked={props.publicidad && props.publicidad.recautinsvialreg === true ? true : false} id="autorizaInst" />
                                            <label className="form-check-label" htmlFor="autorizaInst">
                                                Autorización Inst. Vial
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtPuso} defaultChecked={props.publicidad && props.publicidad.recusoconfddu === true ? true : false} id="paraQueUso" />
                                            <label className="form-check-label" htmlFor="paraQueUso">
                                                Para que Uso
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="container mx-auto row px-0">
                                    <div className="col-md-12 mx-auto py-2 px-0">
                                        <div className="input-group input-group-sm mx-auto mb-3 m-0 w-100 px-0">
                                            <div className="input-group-prepend" >
                                                <span className="input-group-text w-100">Dirección de Ubicación: </span>
                                            </div>
                                            <textarea onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtUbicacion} className="form-control text-uppercase" name='ubicacion' defaultValue={props.publicidad && props.publicidad.ubicacion !== null ? props.publicidad.ubicacion.trim().toUpperCase() : ''} style={{ height: 70 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f8f9fa" }}>
                <button ref={btnAcepta} disabled={operacion === 4 ? true : false} onClick={onChangeValidar} className="btn btn-success btn-sm rounded-pill"><i className="fas fa-check-circle">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}